export default __webpack_public_path__ + "static/media/10-Nature.292a716f.jpg";